import { render } from "./MobileOtpVerify.vue?vue&type=template&id=c4015040&scoped=true"
import script from "./MobileOtpVerify.vue?vue&type=script&lang=js"
export * from "./MobileOtpVerify.vue?vue&type=script&lang=js"

import "./MobileOtpVerify.vue?vue&type=style&index=0&id=c4015040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4015040"]])

export default __exports__